// Exact overview routes only. Invoice layout is the approved reference and stays untouched.
// Editors, settings, scanner/POS, messaging and customer-facing portals are deliberately excluded.
export const COMPACT_OVERVIEW_ROUTES = new Set([
  '/', '/dashboard', '/offertes', '/bestelbonnen', '/shop-bestellingen', '/leveringsbonnen', '/proforma', '/creditnotas',
  '/documenten', '/artikels', '/klanten', '/leveranciers', '/vervoerders', '/contacten',
  '/voorraad', '/inventaris', '/aankoopbestellingen', '/aankopen', '/herhaald', '/bank',
  '/herinneringen', '/betalingsherinneringen-overzicht', '/inkomende-documenten',
  '/verkoop', '/commissies', '/verkoop-rapport', '/kosten-rapport', '/top-artikels', '/top-klanten', '/kortingen-audit',
  '/zoek-referentie', '/btw', '/btw-aangifte', '/boekhoudexport', '/rapportage',
  '/gebruikers', '/bedrijven', '/audit-log', '/webhook-monitor', '/notificaties', '/klantbezoeken', '/routeplanning',
]);